import { useState } from 'react';

import { isEqual } from 'lodash';

import { Option } from '@components/Formik/MultiSelectFilter/types';
import { SearchFormValues } from '@components/Formik/SearchMembersForm/types';
import { INITIAL_FILTERS } from '@domui-presenters/web/components/DistrictMembersFilters/constants';
import {
  MEMBER_FILTERS,
  MemberFilter,
} from '@presenters/web/components/DistrictMembersFilters/types';

import { getDefaultFilters } from '@domui-use-cases/districts';

export const useMembersFilters = (options?: Option[]) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchValues, setSearchValues] = useState<SearchFormValues>({
    name: '',
    email: '',
  });

  // Set predefined filters if queryParams are set or initial values
  const defaultFilters = getDefaultFilters(INITIAL_FILTERS, options);
  const [filterValues, setFilterValues] = useState<MemberFilter>(
    defaultFilters as MemberFilter
  );

  const handleSearch = ({ name, email }: SearchFormValues) => {
    setSearchValues({ name, email });
    handleResetFilters();
  };

  const handleResetFilters = (filterName?: string): void => {
    if (
      filterName &&
      filterValues[filterName as keyof MemberFilter].length === 0
    ) {
      return;
    }
    setCurrentPage(1);
    // Check if filterName exists in Enum object as value
    // and reset state for this filterName
    if (
      filterName &&
      Object.values(MEMBER_FILTERS).includes(filterName as MEMBER_FILTERS)
    ) {
      setFilterValues({ ...filterValues, [filterName]: [] });
    } else {
      setFilterValues(INITIAL_FILTERS);
    }
  };

  const handleApplyFilters = (values: Option[], name: MEMBER_FILTERS) => {
    const updatedFilters = {
      ...filterValues,
      [name]: values,
    };

    if (!isEqual(filterValues, updatedFilters)) {
      setCurrentPage(1);
      setFilterValues(updatedFilters);
      setSearchValues({ ...searchValues });
    }
  };

  const handlePagination = (
    event: React.SyntheticEvent,
    pageNumber: number
  ) => {
    event.preventDefault();
    setCurrentPage(pageNumber);
  };

  return {
    searchValues,
    filterValues,
    currentPage,
    setCurrentPage,
    handleSearch,
    handleApplyFilters,
    handleResetFilters,
    handlePagination,
  };
};
